import { useContext } from 'react';
import {
  Form, FieldSet, Button, ColumnLayout, Column, Typography, ModalBody,
} from '@visionplanner/ui-react-material';
import isEqual from 'lodash.isequal';
import { invoiceInformationFormSchema } from './partner-form-validation';
import { saveInvoiceInformation } from '../partner-onboarding.requests';
import { StyledModalFooter } from '../../styles';
import { PartnerContext } from '../partner-context';
import { types } from '../partner-onboarding.reducer';
import { useAsyncCallback } from '../../../common/custom-hooks/use-async-callback';

/** Component to add invoice-details of a partner */

const InvoiceInformation = () => {
  const {
    activeStep,
    setActiveStep,
    state,
    dispatch,
  } = useContext(PartnerContext);
  const { partnerId, invoiceInformation } = state;

  const handleSubmit = useAsyncCallback(async (formValues) => {
    if (!isEqual(invoiceInformation, formValues)) {
      const { lastModified } = await saveInvoiceInformation(partnerId, formValues);
      dispatch({
        type: types.saveInvoiceInformation,
        payload: { lastModified, formValues },
      });
    }
    setActiveStep(activeStep + 1);
  }, [activeStep, dispatch, invoiceInformation, partnerId, setActiveStep]);
  return (
    <>
      <Form
        initialValues={invoiceInformation}
        validateFormSchema={invoiceInformationFormSchema}
        onSubmit={handleSubmit}
        dataTa="invoice-information-form"
        isInitiallyValid={invoiceInformationFormSchema.isValidSync(invoiceInformation)}
        className="full-height flex-column"
      >
        {
          ({
            isValid, isSubmitting,
          }) => (
            <>
              <ModalBody>
                <Typography use="h6">Factuurinformatie</Typography>
                <ColumnLayout>
                  <Column span={5}>
                    <FieldSet
                      type="text"
                      name="accountNumber"
                      label="Bankrekeningnummer"
                      dataTa="account-number"
                      required
                    />
                  </Column>
                </ColumnLayout>
                <ColumnLayout>
                  <Column span={9}>
                    <FieldSet
                      type="email"
                      name="invoiceEmail"
                      label="Factuur E-mailadres"
                      required
                      dataTa="invoice-email"
                    />
                  </Column>
                </ColumnLayout>
                <ColumnLayout>
                  <Column span={5}>
                    <FieldSet
                      type="text"
                      name="bankName"
                      label="Naam bank"
                      required
                      dataTa="bank-name"
                    />
                  </Column>
                </ColumnLayout>
                <ColumnLayout>
                  <Column span={5}>
                    <FieldSet
                      type="text"
                      name="bankAccountName"
                      label="Ten name van"
                      required
                      dataTa="bank-account-name"
                    />
                  </Column>
                </ColumnLayout>
              </ModalBody>
              <StyledModalFooter>
                <Button buttonType="secondary" dataTa="go-to-firm-logo" onClick={() => setActiveStep(activeStep - 1)}>Vorige</Button>
                <Button type="submit" dataTa="go-to-review-and-submit" disabled={!isValid || isSubmitting}>Volgende</Button>
              </StyledModalFooter>
            </>
          )
        }
      </Form>
    </>
  );
};

export default InvoiceInformation;
